import React from 'react';

const JobCard = ({ job, onViewDetails }) => {
    return (
        <div className="col-lg-4 col-md-6 mb-4" data-aos="fade-up">
            <div className="job-card">
                <div className="job-card-content">
                    <h3 className="job-card-title">{job.title}</h3>
                    <p className="job-card-location">{job.location}</p>
                    <p className="job-card-description">{job.description}</p>
                    <button className="see-more-link" onClick={() => onViewDetails(job)}>
                        VIEW DETAILS
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JobCard;
